import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { QUERY_KEYS } from 'src/constants'
import { accountsService } from 'src/services/accounts.service'

const useRemoveAccountIcon = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation(() => accountsService.removeAccountIcon(accountId!), {
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT, accountId])
    },
  })
}

export { useRemoveAccountIcon }
